/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type { AgentBlocksService } from './AgentBlocksService';
import { agentBlocksService } from './AgentBlocksService';
import type { AgentConfigsService } from './AgentConfigsService';
import { agentConfigsService } from './AgentConfigsService';
import type { AgentService } from './AgentService';
import { agentService } from './AgentService';
import type { AgentToolsService } from './AgentToolsService';
import { agentToolsService } from './AgentToolsService';
import type { AgentVoiceService } from './AgentVoiceService';
import { agentVoiceService } from './AgentVoiceService';
import type { AvailabilityService } from './AvailabilityService';
import { availabilityService } from './AvailabilityService';
import type { CallsService } from './CallsService';
import { callsService } from './CallsService';
import type { CheckService } from './CheckService';
import { checkService } from './CheckService';
import type { ConversationsService } from './ConversationsService';
import { conversationsService } from './ConversationsService';
import type { CredentialsService } from './CredentialsService';
import { credentialsService } from './CredentialsService';
import type { CustomersService } from './CustomersService';
import { customersService } from './CustomersService';
import type { EmailsService } from './EmailsService';
import { emailsService } from './EmailsService';
import type { EmployeesService } from './EmployeesService';
import { employeesService } from './EmployeesService';
import type { EventsService } from './EventsService';
import { eventsService } from './EventsService';
import type { ExternalCallsService } from './ExternalCallsService';
import { externalCallsService } from './ExternalCallsService';
import type { InternalService } from './InternalService';
import { internalService } from './InternalService';
import type { IssuesService } from './IssuesService';
import { issuesService } from './IssuesService';
import type { LocationsService } from './LocationsService';
import { locationsService } from './LocationsService';
import type { MessagesService } from './MessagesService';
import { messagesService } from './MessagesService';
import type { MessagingService } from './MessagingService';
import { messagingService } from './MessagingService';
import type { NotesService } from './NotesService';
import { notesService } from './NotesService';
import type { OfficeRegionsService } from './OfficeRegionsService';
import { officeRegionsService } from './OfficeRegionsService';
import type { OfficesService } from './OfficesService';
import { officesService } from './OfficesService';
import type { OrganizationsService } from './OrganizationsService';
import { organizationsService } from './OrganizationsService';
import type { RetellService } from './RetellService';
import { retellService } from './RetellService';
import type { RoutesService } from './RoutesService';
import { routesService } from './RoutesService';
import type { ServiceEventsService } from './ServiceEventsService';
import { serviceEventsService } from './ServiceEventsService';
import type { ServicePlansService } from './ServicePlansService';
import { servicePlansService } from './ServicePlansService';
import type { ServicePlanTemplatesService } from './ServicePlanTemplatesService';
import { servicePlanTemplatesService } from './ServicePlanTemplatesService';
import type { ServiceTypeTemplatesService } from './ServiceTypeTemplatesService';
import { serviceTypeTemplatesService } from './ServiceTypeTemplatesService';
import type { SkillsService } from './SkillsService';
import { skillsService } from './SkillsService';
import type { TemplatesService } from './TemplatesService';
import { templatesService } from './TemplatesService';
import type { VoiceSettingsService } from './VoiceSettingsService';
import { voiceSettingsService } from './VoiceSettingsService';
import type { WebhooksService } from './WebhooksService';
import { webhooksService } from './WebhooksService';

export type Services = {
  organizations: OrganizationsService;
  offices: OfficesService;
  officeRegions: OfficeRegionsService;
  customers: CustomersService;
  emails: EmailsService;
  locations: LocationsService;
  notes: NotesService;
  employees: EmployeesService;
  issues: IssuesService;
  credentials: CredentialsService;
  skills: SkillsService;
  serviceTypeTemplates: ServiceTypeTemplatesService;
  servicePlanTemplates: ServicePlanTemplatesService;
  servicePlans: ServicePlansService;
  serviceEvents: ServiceEventsService;
  events: EventsService;
  availability: AvailabilityService;
  routes: RoutesService;
  agent: AgentService;
  agentVoice: AgentVoiceService;
  agentConfigs: AgentConfigsService;
  agentBlocks: AgentBlocksService;
  agentTools: AgentToolsService;
  voiceSettings: VoiceSettingsService;
  check: CheckService;
  calls: CallsService;
  messaging: MessagingService;
  conversations: ConversationsService;
  templates: TemplatesService;
  messages: MessagesService;
  webhooks: WebhooksService;
  retell: RetellService;
  externalCalls: ExternalCallsService;
  internal: InternalService;
};
export const services = {
  organizations: organizationsService,
  offices: officesService,
  officeRegions: officeRegionsService,
  customers: customersService,
  emails: emailsService,
  locations: locationsService,
  notes: notesService,
  employees: employeesService,
  issues: issuesService,
  credentials: credentialsService,
  skills: skillsService,
  serviceTypeTemplates: serviceTypeTemplatesService,
  servicePlanTemplates: servicePlanTemplatesService,
  servicePlans: servicePlansService,
  serviceEvents: serviceEventsService,
  events: eventsService,
  availability: availabilityService,
  routes: routesService,
  agent: agentService,
  agentVoice: agentVoiceService,
  agentConfigs: agentConfigsService,
  agentBlocks: agentBlocksService,
  agentTools: agentToolsService,
  voiceSettings: voiceSettingsService,
  check: checkService,
  calls: callsService,
  messaging: messagingService,
  conversations: conversationsService,
  templates: templatesService,
  messages: messagesService,
  webhooks: webhooksService,
  retell: retellService,
  externalCalls: externalCallsService,
  internal: internalService,
} as const;
